import {NgModule} from '@angular/core';
import {DevExtremeModule, DxSelectBoxModule} from 'devextreme-angular';
import {VisualizarLaudoComponent} from '../visualizar-laudo.component';
import {VisualizarLaudoRotasModule} from './visualizar-laudo-rotas.module';
import {VisualizarLaudoService} from '../visualizar-laudo.service';
import {VgCoreModule} from 'videogular2/compiled/src/core/core';
import {VgBufferingModule} from 'videogular2/compiled/src/buffering/buffering';
import {VgControlsModule} from 'videogular2/compiled/src/controls/controls';
import { CompartilhadoModule } from 'app/compartilhado/compartilhado.module';
import { CoreModule } from 'app/compartilhado/core/core.module';
import { VisualizarImagemOriginalModule } from 'app/laudos-pa/visualizar-imagem-original/modules/visualizar-imagem-original.module';

@NgModule({
  declarations: [
    VisualizarLaudoComponent,
  ],
  imports: [
    VisualizarLaudoRotasModule,
    DxSelectBoxModule,
    CompartilhadoModule,
    VgCoreModule,
    VgControlsModule,
    VisualizarImagemOriginalModule,
    VgBufferingModule,
    DevExtremeModule,
    CoreModule
  ],
  providers: [VisualizarLaudoService]
})

export class VisualizarLaudoModule {
}
